import { render, staticRenderFns } from "./MeetingActItems.vue?vue&type=template&id=11ada6fd&"
import script from "./MeetingActItems.vue?vue&type=script&lang=js&"
export * from "./MeetingActItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports